import React from "react";
import { STATUS_META } from "@/lib/constants";

export default function StatusBadge({ status, className = "" }) {
  const meta = STATUS_META[status] || { label: status || "—", cls: "status-no-date" };
  return (
    <span className={`status-pill ${meta.cls} ${className}`} data-testid={`status-${status}`}>
      {meta.label}
    </span>
  );
}
